export const PHONE_DISPLAY = "(216) 250-1108";
export const PHONE_TEL = "+12162501108";
export const BRAND = "T Will Cater 2 U";
export const TAGLINE = "We cater so you can enjoy!";
export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_twill-cater-2-u/artifacts/1s898qjo_file_00000000d370822fa39ba841b2d0e701.png";

export const MENU = [
  {
    id: "fish-fry-friday",
    name: "Fish Fry Friday",
    price: "20",
    cents: "00",
    tag: "Friday Special",
    featured: true,
    desc: "Fridays only — 2 pieces of golden fried fish, a serving of spaghetti, garlic bread, and one soda.",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_twill-cater-2-u/artifacts/3z7ujxbw_file_0000000037ac81f9968a69b6c223d9d4.png",
  },
  {
    id: "spaghetti-dinner",
    name: "Spaghetti Dinner",
    price: "20",
    cents: "00",
    tag: "The Full Plate",
    desc: "The complete combo: 1 serving of spaghetti, 5 wing dings, and a serving of baked beans.",
    img: "https://images.unsplash.com/photo-1516100882582-96c3a05fe590?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxzcGFnaGV0dGklMjBwYXN0YSUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3ODU4ODc4NTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "spaghetti",
    name: "Spaghetti",
    price: "7",
    cents: "50",
    tag: "Solo Serving",
    desc: "Classic spaghetti twirled in our rich signature sauce. Comfort in every bite.",
    img: "https://images.unsplash.com/photo-1598866594230-a7c12756260f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  },
  {
    id: "chicken-wings",
    name: "10 Chicken Wings",
    price: "10",
    cents: "00",
    tag: "Served With Pop",
    desc: "One serving of 10 crispy wing dings — paired with an ice-cold pop.",
    img: "https://images.unsplash.com/photo-1762631883174-6ea8c0cdc5ba?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  },
  {
    id: "baked-beans",
    name: "Baked Beans",
    price: "7",
    cents: "50",
    tag: "The Sidekick",
    desc: "Slow-cooked baked beans, deep and smoky. The side that steals the show.",
    img: "https://images.unsplash.com/photo-1602873520153-ec56ca3c205b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxiYWtlZCUyMGJlYW5zJTIwcnVzdGljfGVufDB8fHx8MTc4NTg4Nzg1OXww&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMG =
  "https://images.unsplash.com/photo-1633241394397-927cc4ec0845?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxjaGVmJTIwY29va2luZyUyMGtpdGNoZW4lMjBkYXJrfGVufDB8fHx8MTc4NTg4Nzg1OXww&ixlib=rb-4.1.0&q=85";

export const MANIFESTO = [
  {
    n: "01",
    title: "Made To Order",
    body: "Every plate is cooked fresh for your gathering — never mass-produced, never reheated.",
  },
  {
    n: "02",
    title: "Comfort First",
    body: "Spaghetti, wings, beans — the food people actually want to eat. Homestyle, generous, real.",
  },
  {
    n: "03",
    title: "We Come To You",
    body: "Small get-togethers or big celebrations, we cater it so you can kick back and enjoy.",
  },
];
